import gsap from "gsap";

/** COMPANY PROFILE 装飾画像（item-1）の出現演出。ここを編集して調整 */
const reveal = {
  /** 不透明度の補間時間（秒）。イージングは常に線形（等速） */
  opacityDuration: 1.6,
  /** 横移動（transform）の補間時間（秒） */
  moveDuration: 1.4,
  /** 横移動・スケールのみ。opacity にはイージングをかけない */
  moveEase: "power4.out",
  /** 表示開始時の拡大率（move と同じトゥーンで 1 に近づく） */
  scaleFrom: 0.93,
  leftFromX: -60,
  rightFromX: 60,
  intersectionRootMargin: "0px 0px -15% 0px",
  intersectionThreshold: 0.15,
} as const;

type ItemSide = "left" | "right";

const startXForSide = (side: ItemSide) =>
  side === "right" ? reveal.rightFromX : reveal.leftFromX;

export const companyProfileItemsReveal = () => {
  const section = document.getElementById("company-profile");
  if (!section) return;

  const left = section.querySelector<HTMLElement>(
    '[data-company-profile-item="left"]',
  );
  const right = section.querySelector<HTMLElement>(
    '[data-company-profile-item="right"]',
  );

  const items = [left, right].filter(Boolean) as HTMLElement[];
  if (items.length === 0) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (prefersReducedMotion) {
    gsap.set(items, {
      opacity: 1,
      x: 0,
      scale: 1,
      clearProps: "transform",
    });
    return;
  }

  const observers: IntersectionObserver[] = [];

  const runReveal = (el: HTMLElement, side: ItemSide) => {
    gsap.set(el, {
      opacity: 0,
      x: startXForSide(side),
      scale: reveal.scaleFrom,
      force3D: true,
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          gsap
            .timeline({
              onStart: () => {
                el.style.willChange = "opacity, transform";
              },
              onComplete: () => {
                el.style.willChange = "";
              },
            })
            .to(
              el,
              {
                opacity: 1,
                duration: reveal.opacityDuration,
                ease: "none",
                force3D: true,
              },
              0,
            )
            .to(
              el,
              {
                x: 0,
                scale: 1,
                duration: reveal.moveDuration,
                ease: reveal.moveEase,
                force3D: true,
              },
              0,
            );

          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: reveal.intersectionRootMargin,
        threshold: reveal.intersectionThreshold,
      },
    );

    observer.observe(el);
    observers.push(observer);
  };

  if (left) runReveal(left, "left");
  if (right) runReveal(right, "right");

  return () => {
    observers.forEach((o) => o.disconnect());
    gsap.killTweensOf(items);
  };
};
